import Image from 'next/image'
import { Intercom } from 'react-live-chat-loader'
import { CTASection } from '../components/marketing/CTASection'
import { Header } from '../components/marketing/Header'
import Meta from '../components/Meta'
import { Button } from '../designsystem/Button'
import { SignupButton } from '../designsystem/SignupButton'
import { Marketing, SubHeadline } from '../designsystem/Text'

export default function About() {
  return (
    <div className='bg-gray-50'>
      <Header />
      <Intercom color='#608BD8' />
      <Meta
        title='Pricing – GraphCDN'
        description='Free up to 5M requests per month, only $10 per additional 1M requests per month afterwards.'
      />
      <div className='max-w-4xl px-6 mx-auto mt-12 mb-8 text-center sm:px-6 sm:mt-24'>
        <Marketing.H1>Pricing that scales</Marketing.H1>
      </div>

      <div className='max-w-6xl mx-auto'>
        <PricingCard />
      </div>

      <div className='max-w-6xl px-6 mx-auto sm:px-12 pb-36'>
        <div className='flex flex-col space-y-8 sm:text-center md:text-left md:flex-row md:space-y-0'>
          <div style={{ flex: 2 }} className='space-y-4'>
            <Marketing.H3>Individual enterprise solutions</Marketing.H3>
            <p className='font-medium text-gray gotham opacity-60'>
              Get more than a billion API requests per month? Contact us for
              volume discounts, dedicated setup help, priority support and
              GraphQL consulting.
            </p>
          </div>
          <div className='flex flex-1 sm:justify-center sm:items-center'>
            <a
              onClick={(evt) => {
                // If Intercom is loaded, send them there
                // otherwise send them to the email link below
                // @ts-ignore
                if (window.Intercom?.booted) {
                  evt.preventDefault()
                  // @ts-ignore
                  window.Intercom('show')
                }
              }}
              href='mailto:sales@graphcdn.io?subject=Enterprise%20contract'
            >
              <Button>Contact sales</Button>
            </a>
          </div>
        </div>
      </div>

      <CTASection />
    </div>
  )
}

function PricingCard(props) {
  return (
    <>
      <svg
        className='hidden w-full h-auto md:block gotham'
        viewBox='0 0 1440 845'
        fill='none'
        {...props}
      >
        <g filter='url(#filter1)'>
          <rect x={64} y={78} width={1312} height={587} rx={16} fill='#fff' />
          <text
            fill='#608BD8'
            style={{
              whiteSpace: 'pre',
              fontWeight: 500,
            }}
            className='gotham'
            fontSize={38}
            letterSpacing='0em'
          >
            <tspan x={112} y={427.9}>
              {'5m requests per '}
            </tspan>
            <tspan x={112} y={476.9}>
              {'month for free.'}
            </tspan>
          </text>
          <text
            opacity={0.5}
            fill='#3B4C6A'
            style={{
              whiteSpace: 'pre',
              fontWeight: 500,
            }}
            className='gotham'
            fontSize={38}
            letterSpacing='0em'
          >
            <tspan x={642} y={427.9}>
              {'$10 per additonal 1m '}
            </tspan>
            <tspan x={642} y={476.9}>
              {'requests per month.'}
            </tspan>
          </text>
          <path opacity={0.15} stroke='#3B4C6A' d='M594.5 78L594.5 538' />
          <path opacity={0.15} stroke='#3B4C6A' d='M1376 538.5L64 538.5' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M477.17 269.632a4 4 0 00-4.771-3.925l-76.655 15.057a4 4 0 00-3.229 3.925v54.624a4 4 0 004 4h76.655a4 4 0 004-4v-69.681zm8 69.681a4 4 0 004 4h78.656a2 2 0 002-2v-92.312a2 2 0 00-2.386-1.963l-79.041 15.526a4 4 0 00-3.229 3.925v72.824zm-185.31-36.424a4 4 0 013.229-3.925l76.655-15.057a4 4 0 014.771 3.925v51.481a4 4 0 01-4 4H303.86a4 4 0 01-4-4v-36.424zm-8 3.143a4 4 0 00-4.771-3.925l-76.655 15.057a4.001 4.001 0 00-3.23 3.925v18.224a4 4 0 004 4h76.656a4 4 0 004-4v-33.281zm-178.245 30.15l80.819-15.875a4 4 0 014.77 3.925v15.081a4 4 0 01-3.999 4H114a2 2 0 01-2-2v-3.168a2 2 0 011.615-1.963z'
            fill='#608BD8'
          />
          <path
            opacity={0.2}
            fillRule='evenodd'
            clipRule='evenodd'
            d='M1354 83.772c0-2.553-2.36-4.453-4.85-3.908l-77 16.815a4 4 0 00-3.15 3.908V339a4 4 0 004 4h77a4 4 0 004-4V83.772zM1362 339a4 4 0 004 4h8c1.1 0 2-.895 2-2V93.871c0-6.688-4.05-12.255-9.64-14.689-2.21-.96-4.36.931-4.36 3.337V339zm-744-97.864a2 2 0 011.573-1.954l80.574-17.595a4 4 0 014.853 3.908V339a4 4 0 01-4 4h-81a2 2 0 01-2-2v-99.864zM717 343a4 4 0 01-4-4V222.001a4 4 0 013.147-3.908l77-16.814a3.999 3.999 0 014.853 3.907V339a4 4 0 01-4 4h-77zm93 0a4 4 0 01-4-4V201.693a4 4 0 013.147-3.908l77-16.815a4 4 0 014.853 3.908V339a4 4 0 01-4 4h-77zm93 0a4 4 0 01-4-4V181.384a4 4 0 013.147-3.908l76-16.596a4 4 0 014.853 3.908V339a4 4 0 01-4 4h-76zm92 0a4 4 0 01-4-4V161.294a4 4 0 013.147-3.908l77.003-16.815c2.49-.544 4.85 1.355 4.85 3.908V339a4 4 0 01-4 4h-77zm262 0a4 4 0 004-4V104.08c0-2.553-2.36-4.452-4.85-3.907l-76 16.596a4 4 0 00-3.15 3.908V339a4 4 0 004 4h76zm-92 0a4 4 0 004-4V124.171c0-2.553-2.36-4.453-4.85-3.908l-77 16.814a4 4 0 00-3.15 3.908V339a4 4 0 004 4h77z'
            fill='#3B4C6A'
          />
          <text
            opacity={0.4}
            fill='#3B4C6A'
            style={{
              whiteSpace: 'pre',
              fontWeight: 500,
            }}
            className='gotham'
            fontSize={24}
            letterSpacing='0em'
          >
            <tspan x={112} y={512.7}>
              {'No credit card required'}
            </tspan>
          </text>
          <text
            fill='#608BD8'
            style={{
              whiteSpace: 'pre',
              fontWeight: 500,
            }}
            className='gotham'
            fontSize={24}
            letterSpacing='0em'
          >
            <tspan x={523.359} y={608.7}>
              {'Unlimited users & unlimited APIs'}
            </tspan>
          </text>
        </g>
        <defs>
          <filter
            id='filter1'
            x={-65}
            y={0}
            width={1570}
            height={845}
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity={0} result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={3.39155} />
            <feGaussianBlur stdDeviation={4.28932} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0125 0' />
            <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={6.38599} />
            <feGaussianBlur stdDeviation={8.0764} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.025 0' />
            <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={11.3915} />
            <feGaussianBlur stdDeviation={14.4069} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0375 0' />
            <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={21.3066} />
            <feGaussianBlur stdDeviation={26.9466} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0535 0' />
            <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={51} />
            <feGaussianBlur stdDeviation={64.5} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.03 0' />
            <feBlend in2='effect4_dropShadow' result='effect5_dropShadow' />
            <feBlend
              in='SourceGraphic'
              in2='effect5_dropShadow'
              result='shape'
            />
          </filter>
        </defs>
      </svg>
      <svg
        className='block w-full h-auto md:hidden gotham'
        viewBox='0 0 375 855'
        fill='none'
        {...props}
      >
        <g filter='url(#filter0_ddddd)'>
          <g>
            <rect x={12} y={78} width={351} height={597} rx={10} fill='#fff' />
            <text
              fill='#608BD8'
              style={{
                whiteSpace: 'pre',
              }}
              fontFamily='Gotham'
              fontSize={26}
              letterSpacing='0em'
            >
              <tspan x={36} y={226.8}>
                {'5m requests per '}
              </tspan>
              <tspan x={36} y={260.8}>
                {'month for free.'}
              </tspan>
            </text>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M282.443 123.058a4 4 0 00-4.744-3.93l-50.989 9.658a4 4 0 00-3.255 3.93V167a4 4 0 004 4h50.988a4 4 0 004-4v-43.942zM288.017 167a4 4 0 004 4H345a2 2 0 002-2v-60.584a2 2 0 00-2.372-1.965l-53.355 10.106a4 4 0 00-3.256 3.93V167zm-129.119-22.057a4 4 0 013.256-3.93l50.982-9.656a4 4 0 014.745 3.93V167a4 4 0 01-4 4h-50.983a4 4 0 01-4-4v-22.057zm-5.574 2.571a4 4 0 00-4.745-3.93l-50.988 9.658a4 4 0 00-3.255 3.93V167a4 4 0 004 4h50.988a4 4 0 004-4v-19.486zm-123.696 18.6l54.389-10.301a4 4 0 014.744 3.93V167a4 4 0 01-4 4H30a2 2 0 01-2-2v-.921a2 2 0 011.628-1.965z'
              fill='#608BD8'
            />
            <text
              opacity={0.4}
              fill='#3B4C6A'
              style={{
                whiteSpace: 'pre',
              }}
              fontFamily='Gotham'
              fontSize={20}
              letterSpacing='0em'
            >
              <tspan x={36} y={301}>
                {'No credit card required'}
              </tspan>
            </text>
            <text
              opacity={0.6}
              fill='#3B4C6A'
              style={{
                whiteSpace: 'pre',
              }}
              fontFamily='Gotham'
              fontSize={26}
              letterSpacing='0em'
            >
              <tspan x={36} y={599.8}>
                {'$10 per additonal 1m '}
              </tspan>
              <tspan x={36} y={633.8}>
                {'requests per month.'}
              </tspan>
            </text>
            <path
              opacity={0.2}
              fillRule='evenodd'
              clipRule='evenodd'
              d='M182.688 460.779a4 4 0 013.143-3.907l53.776-11.784a4 4 0 014.856 3.907V539a4 4 0 01-4 4h-53.775a4 4 0 01-4-4v-78.221zM312.856 539a4 4 0 01-4 4h-54.51a4 4 0 01-4-4v-93.047a4 4 0 013.144-3.907l54.509-11.946a4.002 4.002 0 014.857 3.908V539zm-198.562-63.233a4 4 0 013.143-3.907l54.511-11.946a4 4 0 014.856 3.908V539a4 4 0 01-4 4h-54.51a4 4 0 01-4-4v-63.233zM45.9 490.754a4 4 0 013.144-3.907l54.51-11.945a4 4 0 014.856 3.907V539a4 4 0 01-4 4H49.9a4 4 0 01-4-4v-48.246zM318.74 539a4 4 0 004 4h37.912a2 2 0 002-2V423.096a4 4 0 00-4.856-3.907l-35.912 7.869a4 4 0 00-3.144 3.907V539zM13.572 494.62l21.589-4.73a4 4 0 014.856 3.907V539a4 4 0 01-4 4H14a2 2 0 01-2-2v-44.426c0-.939.654-1.752 1.572-1.954z'
              fill='#3B4C6A'
            />
            <path opacity={0.15} stroke='#3B4C6A' d='M385 348.5L12 348.5' />
          </g>
        </g>
        <defs>
          <filter
            id='filter0_ddddd'
            x={-117}
            y={0}
            width={609}
            height={855}
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity={0} result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={3.39155} />
            <feGaussianBlur stdDeviation={4.28932} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0125 0' />
            <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={6.38599} />
            <feGaussianBlur stdDeviation={8.0764} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.025 0' />
            <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={11.3915} />
            <feGaussianBlur stdDeviation={14.4069} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0375 0' />
            <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={21.3066} />
            <feGaussianBlur stdDeviation={26.9466} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0535 0' />
            <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
            <feColorMatrix
              in='SourceAlpha'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            />
            <feOffset dy={51} />
            <feGaussianBlur stdDeviation={64.5} />
            <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.03 0' />
            <feBlend in2='effect4_dropShadow' result='effect5_dropShadow' />
            <feBlend
              in='SourceGraphic'
              in2='effect5_dropShadow'
              result='shape'
            />
          </filter>
          <clipPath id='clip0'>
            <rect x={12} y={78} width={351} height={597} rx={10} fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}
